export default "__VITE_ASSET__pHhDDAZ$__"